import React, { useEffect, useState } from "react";
import { Alert, Button, Chip, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { abrirPapeletaPdf, dinero, listarPagosEmpleado } from "../services/planillasService";

// Pagos ya emitidos a un empleado (lo que antes era "Ver Planillas"), con su papeleta en PDF.
export default function PagosDialog({ empleado, onClose }) {
  const [datos, setDatos] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    let activo = true;
    listarPagosEmpleado(empleado.id)
      .then(({ data }) => activo && setDatos(data))
      .catch((e) => activo && setError(e?.response?.data?.error || "No se pudieron cargar los pagos."));
    return () => { activo = false; };
  }, [empleado.id]);

  const abrir = async (id) => {
    setError("");
    try { await abrirPapeletaPdf(id); } catch (e) { setError(e?.response?.data?.error || "No se pudo generar la papeleta."); }
  };

  return (
    <Dialog open onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ py: 1, fontSize: "0.95rem", fontWeight: 800 }}>Pagos de {empleado.nombre_completo}</DialogTitle>
      <DialogContent dividers sx={{ p: 0 }}>
        {error && <Alert severity="error" sx={{ m: 1, py: 0 }}>{error}</Alert>}
        {!datos && !error && <CircularProgress size={20} sx={{ m: 2 }} />}
        {datos && (datos.items.length === 0 ? (
          <Typography sx={{ p: 2 }} color="text.secondary">Todavía no tiene pagos registrados.</Typography>
        ) : (
          <TableContainer sx={{ maxHeight: 420 }}>
            <Table size="small" stickyHeader sx={{ "& .MuiTableCell-root": { py: 0.4, px: 1, fontSize: 12 } }}>
              <TableHead>
                <TableRow>{["Fecha", "Correspondiente a", "Cheque", "Banco", "Monto (Bs)", "Estado", ""].map((h, i) => <TableCell key={h || i} align={i === 4 ? "right" : "left"} sx={{ fontWeight: 800 }}>{h}</TableCell>)}</TableRow>
              </TableHead>
              <TableBody>
                {datos.items.map((p) => (
                  <TableRow key={p.id_pago} hover>
                    <TableCell>{p.fecha}</TableCell>
                    <TableCell>{p.mes}</TableCell>
                    <TableCell>{p.nocheque}</TableCell>
                    <TableCell>{p.banco}</TableCell>
                    <TableCell align="right">{dinero(p.bolivianos)}</TableCell>
                    <TableCell>{p.anulado === "si" ? <Chip size="small" color="error" label="Anulado" /> : "Pagado"}</TableCell>
                    <TableCell align="right"><Button size="small" startIcon={<PictureAsPdfIcon fontSize="small" />} sx={{ py: 0, fontSize: 11 }} onClick={() => abrir(p.id_pago)}>Papeleta</Button></TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ))}
      </DialogContent>
      <DialogActions sx={{ p: 0.75 }}><Button size="small" onClick={onClose}>Cerrar</Button></DialogActions>
    </Dialog>
  );
}
